<div class="component-card">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'Membership Plans'|translate}}</h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-50">
                <button type="button" class="search_btn_icon"><i class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" placeholder="Search...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button>
            </div>
            <button class="btn_in_color w-25" (click)="addNewMembershipPlans()">{{ 'Add New' | translate}} +</button>
        </div>
    </div>
</div>

<div class="div_grid" style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden;" infiniteScroll
    [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMoreMembershipPlans()"
    [scrollWindow]="false">
    <div *ngFor="let plan of membershipPlanList" class="vertical_component_card">
        <div class="component-list-card h-100 d-flex flex-column">
            <div class="text-center mem_plan_text mb-2 ">
                <label class="lbl_name">{{plan.Name}}</label>
                <label class="lbl_price">{{plan.Price}}</label>
                <div class="min-h-title">
                    <label class="lbl_title">{{plan.Title}}</label>
                    <label class="lbl_desc">{{plan.Description}}</label>
                </div>
                <label class="lbl_num">{{'Number of venues'|translate}}</label>
                <label class="lbl_num_of_ven">{{plan.NumberOfVenues}}</label>
            </div>
            <div class="mt-auto">
                <button class="btn_in_color  me-2" (click)="editMembershipPlan(plan.Id , plan)">{{ 'EDIT' |
                    translate}}</button>
                <button class="btn_without_color btn_border_color " (click)="deleteMembershipPlan(plan.Id)">{{ 'DELETE'
                    | translate}}</button>
            </div>
        </div>
    </div>
</div>